import _ from 'lodash'
import { Container, Graphics, Point, Rectangle, ObservablePoint, Text } from 'pixi.js'
import helpers from '../helpers'
import { app } from './index'
import Room from './Room'

export default class Grid extends Graphics {

  constructor(options) {
    super()

    // 横のマスの数
    this.xLength = options.cols || 70
    // 縦のマスの数
    this.yLength = options.rows || 70
    // マスの大きさ
    this.cellSize = options.cellSize || 40
    // ズーム倍率
    this.zoom = options.zoom || 1
    // 分割数
    this.division = options.division || 2
    // 余白のマス数
    this.padding = options.padding || 1
    // 線の太さ
    this.lineWidth = 1
    // 1マス＝3尺(m)
    this.shaku3 = 0.91

    // グリッド線
    this.lines = new Graphics()
    this.lines.name = 'lines'
    this.addChild(this.lines)

    // 下層階レイヤー
    this.underArea = new Graphics()
    this.underArea.name = 'underArea'
    this.addChild(this.underArea)

    // 面積レイヤー
    this.area = new Graphics()
    this.area.name = 'area'
    this.addChild(this.area)
    this.areaLabelX = new Text('0.0m', {fontSize: 12})
    this.area.addChild(this.areaLabelX)
    this.areaLabelY = new Text('0.0m', {fontSize: 12})
    this.areaLabelY.rotation = -90 * (Math.PI / 180)
    this.area.addChild(this.areaLabelY)

    // 1階レイヤー
    this.floor1Floor = new Container()
    this.floor1Floor.name = 'floor1Floor'
    this.floor1Floor.visible = true
    this.addChild(this.floor1Floor)
    this.floor1 = new Container()
    this.floor1.name = 'floor1'
    this.floor1.visible = true
    this.addChild(this.floor1)
    this.floor1Label = new Container()
    this.floor1Label.name = 'floor1Label'
    this.floor1Label.visible = true
    this.addChild(this.floor1Label)

        
    // 2階レイヤー
    this.floor2Floor = new Container()
    this.floor2Floor.name = 'floor2Floor'
    this.floor2Floor.visible = false
    this.addChild(this.floor2Floor)
    this.floor2 = new Container()
    this.floor2.name = 'floor2'
    this.floor2.visible = false
    this.addChild(this.floor2)
    this.floor2Label = new Container()
    this.floor2Label.name = 'floor2Label'
    this.floor2Label.visible = false
    this.addChild(this.floor2Label)

    // 3階レイヤー
    this.floor3Floor = new Container()
    this.floor3Floor.name = 'floor3Floor'
    this.floor3Floor.visible = false
    this.addChild(this.floor3Floor)
    this.floor3 = new Container()
    this.floor3.name = 'floor3'
    this.floor3.visible = false
    this.addChild(this.floor3)
    this.floor3Label = new Container()
    this.floor3Label.name = 'floor3Label'
    this.floor3Label.visible = false
    this.addChild(this.floor3Label)

    // アクティブレイヤー
    this.activeLayer = new Container()
    this.activeLayer.name = 'activeLayer'
    this.addChild(this.activeLayer)

    // 操作ボタンレイヤー
    this.controllers = new Container()
    this.controllers.name = 'controllers'
    this.addChild(this.controllers)

    this.scroll = new ObservablePoint(this.updateScroll, this, 0, 0)

    this.update()

    this.bindDragEvents()

    return this
  }

  get size() {
    return this.cellSize * this.zoom
  }

  get calcWidth() {
    return this.xLength * this.size
  }

  get calcHeight() {
    return this.yLength * this.size
  }

  get areaX() {
    return this.currentFloor.children.length > 0 ? Math.min(...this.currentFloor.children.map(child => child.position.x)) : 0
  }

  get areaY() {
    return this.currentFloor.children.length > 0 ? Math.min(...this.currentFloor.children.map(child => child.position.y)) : 0
  }

  get areaWidth() {
    return Math.max(0, ...this.currentFloor.children.map(child => child.position.x + child.calcWidth)) - this.areaX
  }

  get areaHeight() {
    return Math.max(0, ...this.currentFloor.children.map(child => child.position.y + child.calcHeight)) - this.areaY
  }

  uniqueId() {
    let ids = []
    let layers = [this.floor1, this.floor2, this.floor3]
    layers.forEach(floor => {
      floor.children.forEach(child => {
        ids.push(child.id)
        if (child.config.type == 'room') {
          child.items.children.forEach(item => {
            ids.push(item.id)
          })
        }
      })
    })

    let id = parseInt(_.uniqueId())
    while (ids.includes(id)) {
      id = parseInt(_.uniqueId())
    }

    return id
  }

  changeFloor(floor) {
    this.activeLayer.children.forEach(instance => instance.blur())

    switch(floor) {
      case 1:
        this.floor1.visible = true
        this.floor1Label.visible = true
        this.floor1Floor.visible = true
        this.floor2.visible = false
        this.floor2Label.visible = false
        this.floor2Floor.visible = false
        this.floor3.visible = false
        this.floor3Label.visible = false
        this.floor3Floor.visible = false
        break
      case 2:
        this.floor1.visible = false
        this.floor1Label.visible = false
        this.floor1Floor.visible = false
        this.floor2.visible = true
        this.floor2Label.visible = true
        this.floor2Floor.visible = true
        this.floor3.visible = false
        this.floor3Label.visible = false
        this.floor3Floor.visible = false
        break
      case 3:
        this.floor1.visible = false
        this.floor1Label.visible = false
        this.floor1Floor.visible = false
        this.floor2.visible = false
        this.floor2Label.visible = false
        this.floor2Floor.visible = false
        this.floor3.visible = true
        this.floor3Label.visible = true
        this.floor3Floor.visible = true
        break
    }

    this.updateArea()
  }

  changeZoom(zoom) {
    this.activeLayer.children.forEach(instance => instance.blur())

    switch (zoom) {
      case 1:
        this.zoom = 0.5
        break
      case 2:
        this.zoom = 0.75
        break
      case 3:
        this.zoom = 1
        break
      case 4:
        this.zoom = 1.25
        break
      case 5:
        this.zoom = 1.5
        break
    }

    this.lines.clear()

    this.update()
  }

  getFloor(floor) {
    switch (floor) {
      case 1: return this.floor1
      case 2: return this.floor2
      case 3: return this.floor3
    }
    return null
  }

  getFloorLabel(floor) {
    switch (floor) {
      case 1: return this.floor1Label
      case 2: return this.floor2Label
      case 3: return this.floor3Label
    }
    return null
  }

  getFloorFloor(floor) {
    switch (floor) {
      case 1: return this.floor1Floor
      case 2: return this.floor2Floor
      case 3: return this.floor3Floor
    }
    return null
  }

  get currentFloorNum() {
    if (this.floor1.visible) return 1
    if (this.floor2.visible) return 2
    if (this.floor3.visible) return 3
  }

  get currentFloor() {
    if (this.floor1.visible) return this.floor1
    if (this.floor2.visible) return this.floor2
    if (this.floor3.visible) return this.floor3
  }

  get underFloor() {
    if (this.floor1.visible) return null
    if (this.floor2.visible) return this.floor1
    if (this.floor3.visible) return this.floor2
  }

  update() {

    // 中心をセンターに
    this.pivot.set(this.calcWidth / 2, this.calcHeight / 2)

    // グリッド線の描画
    this.drawGridLine()

    // 枠線の描画
    this.lines.beginFill(0xFFFFFF, 0)
    this.lines.lineStyle(3, 0x000000)
    this.lines.drawRect(0, 0, this.calcWidth, this.calcHeight)

    this.floor1.children.forEach(child => {
      child.update()
    })
    this.floor2.children.forEach(child => {
      child.update()
    })
    this.floor3.children.forEach(child => {
      child.update()
    })

    this.updateArea()

    this.updateScroll()
  }

  updateArea() {
    this.area.position.set(this.areaX, this.areaY)
    this.area.clear()
    this.area.lineStyle(0, 0x000000)
    this.area.beginFill(0x000000, 0.075)
    this.area.drawRect(0, 0, this.areaWidth, this.areaHeight)
    this.area.lineStyle(1, 0x000000)
    this.area.beginFill(0x000000, 0)
    this.area.moveTo(0, -5).lineTo(0, -10).lineTo(this.areaWidth, -10).lineTo(this.areaWidth, -5)
    this.area.moveTo(-5, 0).lineTo(-10, 0).lineTo(-10, this.areaHeight).lineTo(-5, this.areaHeight)
    this.areaLabelX.text = helpers.methods.numberFormat(_.floor(this.areaWidth / this.size * this.shaku3 * 1000) / 1000, '0,0.[000]') + 'm'
    this.areaLabelX.anchor.set(0.5, 1)
    this.areaLabelX.position.set(this.areaWidth / 2 + 0.5, -13.5)
    this.areaLabelY.text = helpers.methods.numberFormat(_.floor(this.areaHeight / this.size * this.shaku3 * 1000) / 1000, '0,0.[000]') + 'm'
    this.areaLabelY.anchor.set(0.5, 1)
    this.areaLabelY.position.set(-13.5, this.areaHeight / 2 + 0.5)

    this.underArea.clear()
    if (this.underFloor) {
      this.underArea.lineStyle(0, 0x000000)
      this.underArea.beginFill(0xAF8050, 0.2)
      this.underFloor.children
        .filter(child => {
          return child.config.type == 'room' && child.config.upper_floor_shadow
        })
        .forEach(room => {
          this.underArea.drawRect(room.position.x, room.position.y, room.calcWidth, room.calcHeight)
        })
    }
  }

  updateScroll() {
    let x = this.scroll.x
    let y = this.scroll.y

    if (this.calcWidth + (this.size * this.padding) * 2 > app.screen.width) {
      const limitX = (this.calcWidth / 2) + (this.size * this.padding) - (app.screen.width / 2)
      if (_.inRange(x, limitX*-1, limitX) == false) {
        x = x > 0 ? limitX : limitX*-1
      }
    } else {
      x = 0
    }

    if (this.calcHeight + (this.size * this.padding) * 2 > app.screen.height) {
      const limitY = (this.calcHeight / 2) + (this.size * this.padding) - (app.screen.height / 2)
      if (_.inRange(y, limitY*-1, limitY) == false) {
        y = y > 0 ? limitY : limitY*-1
      }
    } else {
      y = 0
    }

    this.position.set(x, y)
  }

  drawGridLine() {

    // X軸のグリッド線
    for (let i = -this.padding; i <= this.yLength + this.padding; i++) {
      let y = i * this.size
      let start = -(this.size * this.padding)
      let end = (this.calcWidth) + (this.size * this.padding)
      this.lines.lineStyle(this.lineWidth, 0x999999, 0.3).moveTo(start, y).lineTo(end, y)
      // X軸の分割線
      if (i < this.yLength + this.padding) {
        for (let j = 1; j <= this.division; j++) {
          let yy = y + (this.size / this.division) * j
          this.lines.lineStyle(this.lineWidth, 0x999999, 0.15).moveTo(start, yy).lineTo(end, yy)
        }
      }
    }

    // Y軸のグリッド線
    for (let i = -this.padding; i <= this.xLength + this.padding; i++) {
      let x = i * this.size
      let start = -(this.size * this.padding)
      let end = (this.calcHeight) + (this.size * this.padding)
      this.lines.lineStyle(this.lineWidth, 0x999999, 0.3).moveTo(x, start).lineTo(x, end)
      // Y軸の分割線
      if (i < this.xLength + this.padding) {
        for (let j = 1; j <= this.division; j++) {
          let xx = x + (this.size / this.division) * j
          this.lines.lineStyle(this.lineWidth, 0x999999, 0.15).moveTo(xx, start).lineTo(xx, end)
        }
      }
    }

  }

  bindDragEvents() {
    this.interactive = true
    this.on('pointerdown', e => {
      const globalPosition = e.data.global
      const anchorPosition = new Point(globalPosition.x - this.x, globalPosition.y - this.y)

      this.activeLayer.children.forEach(instance => instance.blur())

      this.on('pointermove', e => {
        this.scroll.set(globalPosition.x - anchorPosition.x, globalPosition.y - anchorPosition.y)
      })
      this.once('pointerup', e => {
        this.off('pointermove')
        this.off('pointerupoutside')
      })
      this.once('pointerupoutside', e => {
        this.off('pointermove')
        this.off('pointerup')
      })
    })
  }

  captureImage() {

    const CAPTURE_SIZE_WIDTH = 880
    const CAPTURE_SIZE_HEIGHT = 450

    let orgFloor = this.currentFloorNum
    let orgZoom = this.zoom
    let orgScroll = this.scroll.clone()
    let orgWidth = app.renderer.width / app.renderer.resolution
    let orgHeight = app.renderer.height / app.renderer.resolution

    app.renderer.resize(CAPTURE_SIZE_WIDTH, CAPTURE_SIZE_HEIGHT)

    this.activeLayer.children.forEach(instance => instance.blur())

    let capture = (floor, urls) => new Promise((resolve, reject) => {
      this.changeFloor(floor)

      if (this.areaWidth == 0 || this.areaHeight == 0) {
        urls.push('')
        return resolve(urls)
      }

      this.zoom = 1
      this.lines.clear()
      this.update()

      let captureAreaPadding = this.size * 1.5 * 2
      let captureAreaWidth = this.areaWidth + captureAreaPadding
      let captureAreaHeight = this.areaHeight + captureAreaPadding
      this.zoom = Math.min(1, CAPTURE_SIZE_WIDTH / captureAreaWidth, CAPTURE_SIZE_HEIGHT / captureAreaHeight)
      this.lines.clear()
      this.update()

      let offsetX = this.width / 2 - this.size * this.padding
      let offsetY = this.height / 2 - this.size * this.padding
      let captureAreaCenterX = this.areaX + this.areaWidth / 2
      let captureAreaCenterY = this.areaY + this.areaHeight / 2
      let diffX = (orgWidth - CAPTURE_SIZE_WIDTH) * this.zoom
      let diffY = (orgHeight - CAPTURE_SIZE_HEIGHT) * this.zoom
      this.scroll.set(offsetX - captureAreaCenterX - diffX, offsetY - captureAreaCenterY - diffY)

      setTimeout(() => {
        if (helpers.methods.forceCanvas()) {
          urls.push(app.renderer.view.toDataURL('image/png'))
        } else {
          urls.push(app.renderer.extract.base64())
        }
        resolve(urls)
      }, 300)
    })

    return capture(1, [])
      // .then(urls => new Promise((rs, rj) => window.confirm('capture(1)') ? rs(urls) : rj()))
      .then(urls => capture(2, urls))
      // .then(urls => new Promise((rs, rj) => window.confirm('capture(2)') ? rs(urls) : rj()))
      .then(urls => capture(3, urls))
      // .then(urls => new Promise((rs, rj) => window.confirm('capture(3)') ? rs(urls) : rj()))
      .then(urls => {

        app.renderer.resize(orgWidth, orgHeight)
        this.changeFloor(orgFloor)
        this.zoom = orgZoom
        this.scroll.copy(orgScroll)
        this.lines.clear()
        this.update()

        return urls
      })
  }

  // positionResize(container, resizeWidth, resizeHeight) {
  //   this.position.set(
  //     this.x + Math.round(resizeWidth / 2),
  //     this.y + Math.round(resizeHeight / 2),
  //   )

  //   // let X = this.x, Y = this.y

  //   // if (container.width < this.width) {
  //   //   X += resizeWidth / 2
  //   //   // if (X > 0) X = 0
  //   //   // if (X < container.width - this.width) X = container.width - this.width
  //   // } else {
  //   //   X = container.width/2 - this.width/2
  //   // }

  //   // if (container.height < this.height) {
  //   //   Y += resizeHeight / 2
  //   //   // if (Y > 0) Y = 0
  //   //   // if (Y < container.height - this.height) Y = container.height - this.height
  //   // } else {
  //   //   Y = container.height/2 - this.height/2
  //   // }

  //   // this.position.set(X, Y)
  // }
}



// WEBPACK FOOTER //
// ./assets/js/display/Grid.js